import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 12,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 12,
            static: true,
            w: 24,
            x: 0,
            y: 13,
            i: 'c3',
        },
    ],
    md: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 10,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 12,
            i: 'c3',
        },
    ],
    xs: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 12,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 14,
            i: 'c3',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'performance',
                },
                rhsComponents: [
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: '1Y',
                            visiblePeriods: [
                                '1m',
                                '3m',
                                '1y',
                                'mtd',
                                'qtd',
                                'ytd',
                                'all',
                            ],
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-collapse',
            key: 'c2',
            props: {
                lhsComponent: {
                    name: 'performance-chart',
                },
                rhsComponent: {
                    name: 'performance-comparator',
                    props: {
                        // defaultAnalysisType: 'strategy',
                        defaultAnalysisMode: 'individual',
                        defaultNavParam: 'nav_on_assets',
                        defaultStrategy: 'by_entire_account',
                    },
                },
            },
        },
        {
            name: 'canopy-table',
            key: 'c3',
            apiDetails: {
                endpoint: `strategies/explainer/attributions?`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    parent_user_ids: 'parent_user_id,',
                    from_date: 'from_date',
                    to_date: 'to_date',
                    strategy_ids: 'strategy_ids',
                    customer_database_priority: 'customer_database_priority',
                    output_format: 'output_format',
                    usernames: 'usernames',
                    keyword: 'keyword',
                },
            },
            props: {
                requiredQueryFields: ['strategy_ids'],
                dataKey: 'explainer',
                title: '',
                showDownloadOn: ['desktop', 'mobile'],
                columns: [
                    {
                        key: 'strategyName',
                        width: 150,
                        type: 'text',
                        headerText: 'ui.mm.table-headers.strategy-name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'strategyType',
                        width: 150,
                        type: 'text',
                        headerText: 'ui.mm.table-headers.strategy-type',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                    {
                        key: 'username',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.parent-username',
                    },
                    {
                        key: 'childDisplayName',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-display-name',
                        selectedByDefaultOn: ['tablet'],
                    },
                    {
                        key: 'childUsername',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.child-username',
                        selectedByDefaultOn: ['tablet'],
                    },
                    {
                        key: 'capitalGains',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.capital-gains',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'distributions',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.distributions',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'netFundFlow',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.net-fund-flow',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'netGainLoss',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.net-gain-loss',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'returnOnAssets',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.return-on-assets',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'returnOnNetworth',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.return-on-networth',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'unleveragedReturn',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.unleveraged-return',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'startingCashBaseCcy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.starting-cash-baseCcy',
                    },
                    {
                        key: 'startingLoansBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.starting-loans-baseCcy',
                    },
                    {
                        key: 'startingNetworthBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.starting-networth-baseCcy',
                    },
                    {
                        key: 'startingSecuritiesIgnoringLoansBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.starting-securities-ignoring-loans-baseCcy',
                    },
                    {
                        key: 'startingTotalUnleveragedAssetsBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.table-header.starting-total-unleveraged-assets-baseCcy',
                    },
                    {
                        key: 'endingCashBaseCcy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.ending-cash-baseCcy',
                    },
                    {
                        key: 'endingLoansBaseCcy',
                        type: 'amount',
                        headerText: 'ui.mm.table-headers.ending-loans-baseCcy',
                    },
                    {
                        key: 'endingNetworthBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.ending-networth-baseCcy',
                    },
                    {
                        key: 'endingSecuritiesIgnoringLoansBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.ending-securities-ignoring-loans-baseCcy',
                    },
                    {
                        key: 'endingTotalUnleveragedAssetsBaseCcy',
                        type: 'amount',
                        headerText:
                            'ui.mm.table-headers.ending-total-unleveraged-assets-baseCcy',
                    },
                    {
                        key: 'lastRunAt',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.last-run-at',
                        dateFormat: '',
                        toDateFormat: 'DD MMM YYYY h:mm:ss A',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                    },
                    {
                        key: 'latestRecordDate',
                        type: 'date',
                        headerText: 'ui.mm.table-headers.latest-record-date',
                    },
                    // {
                    //     key: 'actions',
                    //     type: 'actions',
                    //     showOnParentTable: true,
                    //     actions: [
                    //         {
                    //             name: 'explain_change_button',
                    //             path: '',
                    //             selectedByDefaultOn: [
                    //                 'desktop',
                    //                 'mobile',
                    //                 'tablet',
                    //             ],
                    //         },
                    //     ],
                    //     headerText: 'table-headers.actions',
                    //     selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                    // },
                ],
                per_page: 25,
                defaultSelection: '',
                ga_event_name: 'Review All Performance',
            },
        },
    ],
};
